const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 5C10.75 4.30964 11.3096 3.75 12 3.75C12.6904 3.75 13.25 4.30964 13.25 5C13.25 5.69036 12.6904 6.25 12 6.25C11.3096 6.25 10.75 5.69036 10.75 5ZM14.1791 6.67771C14.5371 6.21345 14.75 5.63159 14.75 5C14.75 3.48122 13.5188 2.25 12 2.25C10.4812 2.25 9.25 3.48122 9.25 5C9.25 5.63159 9.46292 6.21345 9.82089 6.67771C7.72629 7.53684 6.25 9.59693 6.25 12V17C6.25 18.2458 5.24579 19.25 4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75H9.35431C9.68227 21.9019 10.7456 22.75 12 22.75C13.2544 22.75 14.3177 21.9019 14.6457 20.75H20C20.4142 20.75 20.75 20.4142 20.75 20C20.75 19.5858 20.4142 19.25 20 19.25C18.7542 19.25 17.75 18.2458 17.75 17V12C17.75 9.59693 16.2737 7.53684 14.1791 6.67771ZM14 19.25H16.9978C16.528 18.6237 16.25 17.8449 16.25 17V12C16.25 9.65421 14.3458 7.75 12 7.75C9.65421 7.75 7.75 9.65421 7.75 12V17C7.75 17.8449 7.47196 18.6237 7.00222 19.25H10H14Z",
    fill: props.color
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.c6e5bcaa5c9aa3df4e2365a0b572e4c8.svg";
export { ForwardRef as ReactComponent };